module.exports = __webpack_public_path__ + "static/media/Warenrücksendung_OWA_V3.f39eb44e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/theme/ortho-test/public/Warenrücksendung_OWA_V3.pdf
// module id = 1161
// module chunks = 0